// extracted by mini-css-extract-plugin
module.exports = {"imageWrap":"HDo-","aspectRatioSquare":"HDabz","aspectRatioClassic":"HDab1","aspectRatioWide":"HDab3","aspectRatioVerticalWide":"HDab5","aspectRatioVerticalClassic":"HDab7"};